export default __webpack_public_path__ + "img/final3-4a9cc16a.png";